import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  error,
  success,
} from "../../../../../components/alertMessagesHandler/alert";
import CButton from "../../../../../components/buttons/Button";
import COnlyNumberField from "../../../../../components/inputBoxes/number-input";
import CSwitches from "../../../../../components/inputBoxes/switches";
import { LoadingContext } from "../../../../../context/loadingContext";
import {
  SignUpStatisticsHooks,
  SignUpStatisticsUpdateHooks,
} from "../../hooks/useSignup";

const RegStatisticsCodes = (props) => {
  const { portal_id } = useParams();
  const { setLoading } = useContext(LoadingContext);
  const dispatch = useDispatch();
  const StatsReducer = useSelector((state) => state.BusinessStatsReducer);

  const [FieldsValue, setFieldsValue] = useState();

  useEffect(() => {
    setButtonAutoPopulate();
  }, [props]);

  const setButtonAutoPopulate = () => {
    if (
      props.AutoFillDataProp.data_portal_infos &&
      props.AutoFillDataProp.data_portal_infos[0]["data_pub_stats"][0] &&
      props.AutoFillDataProp.data_portal_infos[0]["data_pub_stats"][0][
      "send_stats"
      ] === 1
    ) {
      document.getElementById("send_stats").checked = true;
    }
  };

  // Statistics data register in registration page using SignUpStatisticsHooks

  const statisticsHandle = async () => {
    setLoading(true);
    const res = await SignUpStatisticsHooks(FieldsValue);
    setLoading(false);
    if (res.status === 200) {
      dispatch({ type: "BUSINESS_STATS_DONE" });
      document.getElementById("pills-quality-tab").click();
      success("Statistics Data created successfully");
    } else {
      error(res.message);
    }
  };

  // Update Statistics page data using SignUpStatisticsUpdateHooks

  const statisticsUpdateHandle = async () => {
    setLoading(true);
    const data = {
      mpi_id: Number(portal_id),
      updateData: FieldsValue,
    };
    const res = await SignUpStatisticsUpdateHooks(data);
    setLoading(false);
    if (res.status === 200) {
      document.getElementById("pills-quality-tab").click();
      success("Statistics Data updated successfully");
    } else {
      error(res.message);
    }
  };

  const HandleFieldsValue = (key, value) => {
    setFieldsValue({ ...FieldsValue, [key]: value });
  };

  const submit = (event) => {
    event.preventDefault();
    if (props.regPage === "update-new-business") {
      statisticsUpdateHandle();
    } else {
      if (StatsReducer === 0) statisticsHandle();
      else document.getElementById("pills-quality-tab").click();
    }
  };

  return (
    <>
      <div className="container">
        <div className="row mb-4">
          <div className="col-md-3 col-sm-12"></div>
          <div className="col-md-6 col-sm-12">
            <form onSubmit={submit}>
              <CSwitches
                required={true}
                choiceListArray={[
                  {
                    id: "send_stats",
                    value: "send_stats",
                    label:
                      "Possibility of providing statistics-The publisher declares that he has the possibility to share statistics of published articles (a file from Google Analytics or another system).",
                  },
                ]}
                name={"send_stats"}
                customClassInput={"mt-5"}
                customClassInputDiv={"mb-4 text-dark"}
                customClassChoice={"ms-3"}
                functionName={(name, state) => {
                  if (state === true) HandleFieldsValue(name, 1);
                  else HandleFieldsValue(name, 0);
                }}
              />
              <p className=" mt-5 text-dark mb-0">
                Net cost of the published article
              </p>
              <COnlyNumberField
                required={true}
                labelName={"$"}
                name={"publishing_cost"}
                pattern={"[0-9]+([.,][0-9]+)?"}
                customClassDiv={"text-dark mb-4 mt-3 input-group"}
                value={
                  props.AutoFillDataProp.data_portal_infos &&
                    props.AutoFillDataProp.data_portal_infos[0][
                    "data_pub_stats"
                    ][0]
                    ? props.AutoFillDataProp.data_portal_infos[0][
                    "data_pub_stats"
                    ][0]["publishing_cost"]
                    : ""
                }
                customClassLabel={
                  "input-group-text bg-transparent border-0 h-100 fs-6 ps-0 fw-bold"
                }
                customClassInput={"bg-primary-soft"}
                functionName={(name, netCost) =>
                  HandleFieldsValue(name, netCost)
                }
              />
              <CButton
                btnClassesDiv={"mt-5 text-center"}
                btnClasses={"btn px-4 fw-bold text-white"}
                IsOutline={false}
                innertext={"Submit"}
                btnCustomStyle={{
                  backgroundColor: "#044389",
                }}
              />
            </form>
          </div>
          <div className="col-md-3 col-sm-12"></div>
        </div>
      </div>
    </>
  );
};

export default RegStatisticsCodes;
